module.exports = __webpack_public_path__ + "img/passkey.d8f7c0bb.svg";